module.exports = __webpack_public_path__ + "media/images/img_twitter-3f1fec3b50a3ece4b8535330143cfea5.png";